import React, { useState } from 'react';
import './Navbar.css';
import Logo from './Logo';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="nav" data-nav>
      <div className="nav-inner">
        <a href="#top" className="nav-logo-link" aria-label="Roonbash home" onClick={() => setMenuOpen(false)}>
          <Logo variant="nav" onLight />
        </a>

        <div className={`nav-links ${menuOpen ? 'nav-links-open' : ''}`}>
          <a href="#services" className="nav-link" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="#process" className="nav-link" onClick={() => setMenuOpen(false)}>Process</a>
          <a href="#why" className="nav-link" onClick={() => setMenuOpen(false)}>Why us</a>
          <a href="#faq" className="nav-link" onClick={() => setMenuOpen(false)}>FAQ</a>
          <a href="#contact" className="nav-cta" data-magnetic onClick={() => setMenuOpen(false)}>Start a project</a>
        </div>

        <button
          type="button"
          className={`nav-burger ${menuOpen ? 'nav-burger-open' : ''}`}
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}
